var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{ref:"body",class:_vm.$style.content,domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }